import { TranslateService } from './../translate/translate.service';
import { Injectable } from '@angular/core';

@Injectable()
export class DecimalFormatterService {

  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor(private translate: TranslateService) {
    // TODO comes from configuration settings
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
  }

  transform(value: number | string, allowGrouping: boolean = false): string {
    value = value != null ? value.toString() : value;
    let [integer, fraction = ""] = (value || "").toString()
      .split(this.DECIMAL_SEPARATOR);

    let newDecimalSeparator = this.translate.currentLang == "nl" ? "," : ".";
    let newThousandSeparator = this.translate.currentLang == "nl" ? "." : ",";

    // fraction = fractionSize > 0
    //   ? newDecimalSeparator + (fraction + PADDING).substring(0, fractionSize)
    //   : "";

    fraction = fraction ? newDecimalSeparator + fraction : "";
    if (allowGrouping) {
      integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, newThousandSeparator);
    }

    return integer + fraction;
  }

  // parse(value: string, fractionSize: number = 2): string {
  //   let [integer, fraction = ""] = (value || "").split(this.DECIMAL_SEPARATOR);

  //   integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");

  //   fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
  //     ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
  //     : "";

  //   return integer + fraction;
  // }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/models/decimal-formatter.service.ts